
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftRight100 as ObiThreewayStackedInleftRight100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-right-100.js';
 
 
 

 
 export const ObiThreewayStackedInleftRight100 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-right-100',
   elementClass: ObiThreewayStackedInleftRight100Element,
   events: {
     
   }
  });
 
 